(function($) {

    function setTabs () {

        var activeTab = $('.sbtl-tab[aria-selected="true"]');

        var activeTabBody = $("#" + activeTab.attr('aria-controls'));

        activeTabBody.show();
        
        activeTabBody.siblings('.sbtl-tab-body').hide();

    }

    $('.sbtl-tab').on('click', function() {

        $(this).attr('aria-selected', 'true');
        $(this).siblings().attr('aria-selected', 'false');

        setTabs();
    });

    setTabs();

} )( jQuery );